import { render } from "./PreLoader.vue?vue&type=template&id=9baa185c"
import script from "./PreLoader.vue?vue&type=script&lang=js"
export * from "./PreLoader.vue?vue&type=script&lang=js"

import "./PreLoader.vue?vue&type=style&index=0&id=9baa185c&lang=css"

import exportComponent from "/Users/user/Projects/Vue/one-invoice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__